import sortBy from 'lodash/sortBy';

import { INTRODUCTION_INDEX } from '../activity-builder.apollo';
import { SectionOrSubSection } from '../activity-builder.constants';
import { getSectionsAndSubSections } from '../activity-builder.utils';
import type { InteractiveLessonSectionFragment } from '../lesson-builder.graphql.generated';

export function groupSections({
  sections,
  slidesToDisplay,
  slidesPerPage,
  isSinglePage,
  currentPage,
}: {
  sections: InteractiveLessonSectionFragment[];
  slidesToDisplay: number[];
  slidesPerPage: number;
  isSinglePage: boolean;
  currentPage?: number;
}): { sortedSections: SectionOrSubSection[][]; totalPages: number } {
  if (
    !slidesToDisplay.length ||
    (isSinglePage &&
      currentPage === 0 &&
      slidesToDisplay.includes(INTRODUCTION_INDEX))
  )
    return { sortedSections: [], totalPages: 0 };

  const sortedSections = sortBy(sections, 'sort');
  const sectionsAndSubSections = getSectionsAndSubSections(sortedSections);
  const filteredSections = sectionsAndSubSections.filter((_, i) =>
    slidesToDisplay.includes(i)
  );

  let groupedSections;

  if (slidesPerPage === 2) {
    groupedSections = filteredSections.reduce(
      (accum, _, i, arr) =>
        i % 2 === 0 ? [...accum, arr.slice(i, i + 2)] : accum,
      [] as SectionOrSubSection[][]
    );
  } else {
    groupedSections = filteredSections.map(s => {
      return [s];
    });
  }

  if (isSinglePage && currentPage !== undefined) {
    const hasCoverPage = slidesToDisplay.includes(INTRODUCTION_INDEX);

    return {
      totalPages: sectionsAndSubSections.length,
      sortedSections: [
        groupedSections[hasCoverPage ? currentPage - 1 : currentPage],
      ],
    };
  } else {
    return {
      totalPages: sectionsAndSubSections.length,
      sortedSections: groupedSections,
    };
  }
}
